import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import NavbarIconsGenericComponent from '../generic-nav-bar/NavbarIconsGenericComponent';
import { startLoadingSearchTrends } from '../../app/actions/statisticActions';
import { startLoadingCatalogModules } from '../../app/actions/catalogModuleActions';

const ListStatisticsEndUserTrends = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const trends = useSelector((state) => state.statistic.searchTrends);
  const { catalogModules } = useSelector((state) => state.catalogModule);
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [catalogmodule_id, setCatalogmoduleId] = useState('');

  const load = (e) => {
    if (e) e.preventDefault();
    dispatch(startLoadingSearchTrends({ from, to, catalogmodule_id }));
  };

  useEffect(() => {
    dispatch(startLoadingCatalogModules());
    dispatch(startLoadingSearchTrends({}));
  }, [dispatch]);

  return (
    <>
      <NavbarIconsGenericComponent componentName="listStatistics" />
      <div className="container mt-4">
        <h2>{t('semanticSearch.stats.trendsTitle', { defaultValue: 'Tendencias de búsqueda' })}</h2>
        <form className="row g-2 align-items-end mb-4" onSubmit={load}>
          <div className="col-md-3">
            <label className="form-label">Desde</label>
            <input type="date" className="form-control" value={from} onChange={(e) => setFrom(e.target.value)} />
          </div>
          <div className="col-md-3">
            <label className="form-label">Hasta</label>
            <input type="date" className="form-control" value={to} onChange={(e) => setTo(e.target.value)} />
          </div>
          <div className="col-md-3">
            <label className="form-label">Módulo</label>
            <select className="form-select" value={catalogmodule_id} onChange={(e) => setCatalogmoduleId(e.target.value)}>
              <option value="">Todos</option>
              {(catalogModules || []).map((m) => (
                <option key={m.id} value={m.id}>{m.name || m.key}</option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <button type="submit" className="btn btn-primary">Aplicar</button>
          </div>
        </form>

        <h4>Top textos</h4>
        <ol>
          {(trends?.topTexts || []).map((row) => (
            <li key={row.text_search}>{row.text_search} ({row.count})</li>
          ))}
        </ol>
        <h4>Últimas búsquedas</h4>
        <ul>
          {(trends?.lastSearches || []).map((row) => (
            <li key={row.id}>{row.text_search} — {row.created_at}</li>
          ))}
        </ul>
        <h4>Más resultados</h4>
        <ul>
          {(trends?.mostHits || []).map((row) => (
            <li key={`m-${row.id}`}>{row.text_search} — {row.total_items}</li>
          ))}
        </ul>
        <h4>Menos resultados</h4>
        <ul>
          {(trends?.leastHits || []).map((row) => (
            <li key={`l-${row.id}`}>{row.text_search} — {row.total_items}</li>
          ))}
        </ul>
        <h4>Más encontradas (ids)</h4>
        <ul>
          {(trends?.topFound || []).map((row) => (
            <li key={row.record_id}>#{row.record_id} ({row.count})</li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default ListStatisticsEndUserTrends;
